import NightskyBackground from "./nightsky/background";
import NightskySocialLinks from "./nightsky/social-links";

export const themes = [
  { background: NightskyBackground, links: NightskySocialLinks }
];
